// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const AllImports = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      d="M9 9c3.314 0 6-1.455 6-3.25S12.314 2.5 9 2.5 3 3.955 3 5.75 5.686 9 9 9ZM3 9c0 1.795 2.686 3.25 6 3.25s6-1.455 6-3.25M3 12.25c0 1.795 2.686 3.25 6 3.25s6-1.455 6-3.25"
    />
  </svg>
);
const ForwardRef = forwardRef(AllImports);
export default ForwardRef;
